module.exports = __webpack_public_path__ + "img/rescue-backgound.8312d48f.png";